import { render } from "./JobChange.vue?vue&type=template&id=0488d99d"
import script from "./JobChange.vue?vue&type=script&lang=js"
export * from "./JobChange.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__